import * as $ from 'jquery';
import 'bootstrap';
import * as Cookies from 'js-cookie';
import {bookingFormCommon} from './c005-bookingform-common';

export class loginForm{
	private $loginError:Array<string> = [];
	$loginCookieName: string      = 'MAB-Enrich-LoginID';

	loginForm(): any{
		let $loginMHNo: any            = $('.login-MHnumber');
		let $loginMHPassword: any      = $('.login-password');

		// chrome known issue:
		// unable to detect password field value/length when autofilled
		// https://stackoverflow.com/questions/35049555/chrome-autofill-autocomplete-no-value-for-password
		// https://bugs.chromium.org/p/chromium/issues/detail?id=669724
		// workaround, detect if username is autofilled, set filled state for both if yes
		if ($loginMHNo.val() != ''){
			$loginMHNo.addClass('input-focused');
			$loginMHNo.parent().find('.booking-form--title').addClass('input-filled');
			$loginMHPassword.addClass('input-focused');
			$loginMHPassword.parent().find('.booking-form--title').addClass('input-filled');
		} else {
			$loginMHNo.removeClass('input-focused');
			$loginMHNo.parent().find('.booking-form--title').removeClass('input-filled');
			$loginMHPassword.removeClass('input-focused');
			$loginMHPassword.parent().find('.booking-form--title').removeClass('input-filled');
		}
	}

	loginFormSubmit(): void {
		$('.login-form').click((evt:any) => {
			evt.preventDefault();
			let _self: any = this;
			let $loginMHNo : any = $('.login-MHnumber');
			let $loginPassword : any = $('.login-password');
			let $loginErrorDiv : any = $('.login-error--validation');
			let $loginValidator: any = $('.login-validator');
			let $rememberMyEnrich: any = $('#login-remember--enrich');
			let $validationSuccess    : any = true;
			_self.$loginError = [];
			$loginErrorDiv.show();

			// validate Login MH no.
			if ($loginMHNo.val() == ''){
				let $loginMHNoValidate:any = $loginMHNo.attr('data-loginmhno');
				_self.$loginError.push('<strong>'+$loginMHNo.parent().find('label').text()+':</strong> '+$loginMHNoValidate);
				$loginMHNo.addClass('has-error');
				$loginMHNo.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$loginMHNo.removeClass('has-error');
				$loginMHNo.parent().find('.booking-form--title').removeClass('has-error');
			}

			// validate Login Password
			if ($loginPassword.val() == ''){
				let $loginPasswordValidate:any = $loginPassword.attr('data-loginmhpassword');
				_self.$loginError.push('<strong>'+$loginPassword.parent().find('label').text()+':</strong> '+$loginPasswordValidate);
				$loginPassword.addClass('has-error');
				$loginPassword.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$loginPassword.removeClass('has-error');
				$loginPassword.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$loginError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$loginError[i] + '</li>');
			}

			if ($validationSuccess) {
				$loginErrorDiv.hide();
				if($rememberMyEnrich.is(':checked')){
					let $cookieIdValue: any = $loginMHNo.val();
					Cookies.set(_self.$loginCookieName, $cookieIdValue);
				} else {
					Cookies.set(_self.$loginCookieName, '');
				}
				$loginErrorDiv.hide();

				let bcommon: any = new bookingFormCommon();
				bcommon.preloader();
				var data:any = {
					'userId': $loginMHNo.val(),
					'password': $loginPassword.val()
				};

				$.ajax({
					type: 'POST',
					url:'/bin/services/new/authuser',
					data: data,
					success: function(msg:any) {
						var json = JSON.parse(msg);
						var responseCode = json.responseCode;

						if (responseCode == "OK") {
							var loginSuccess = $("#exceptionmsg1").attr("data-loginsuccess");
							var d = new Date();
							d.setTime(d.getTime() + (30 * 60 * 1000));
							var expires = "expires="+d.toUTCString();
						//	document.cookie="jade="+json.cookieValue+";"+expires+";path=/";
							document.cookie="phantom="+json.phantomCookieValue+";"+expires+";path=/";
							document.cookie = "userName=" + JSON.parse(json.phantomCookieValue).userName +";"+expires+";path=/";
							document.cookie = "milesCount=" + JSON.parse(json.phantomCookieValue).milesCount + ";"+expires+";path=/";
							document.cookie = "flyerID=" + JSON.parse(json.phantomCookieValue).flyerID + ";"+expires+";path=/"; 
							document.cookie = "memberStatus=" + JSON.parse(json.phantomCookieValue).memberStatus + ";"+expires+";path=/"; 
							bcommon.preloaderClose();
							window.location.href = loginSuccess;
							// Redirect to the configured page from here.
						} else if (responseCode == "PW") {
							$loginErrorDiv.show();
							$loginPassword.addClass('has-error');
							$loginPassword.parent().find('.booking-form--title').addClass('has-error');
							_self.$loginError.push("Invalid Password. You have 4 more attempt(s)");
						} else if (responseCode == "LC") {
							$loginErrorDiv.show();
							// Show the locked user account message here.
							var locked  = $("#exceptionmsg1").attr("data-locked");
							$loginMHNo.addClass('has-error');
							$loginPassword.addClass('has-error');
							$loginPassword.parent().find('.booking-form--title').addClass('has-error');
							_self.$loginError.push("<strong>Account :</strong>"+locked);
						} else if (responseCode == "NA") {
							$loginErrorDiv.show();
							$loginMHNo.addClass('has-error');
							$loginPassword.addClass('has-error');
							$loginPassword.parent().find('.booking-form--title').addClass('has-error');
							_self.$loginError.push("<strong>Account :</strong>Invalid login");
						} else if (responseCode == "W2") {
							$loginErrorDiv.show();
							$loginPassword.addClass('has-error');
							$loginPassword.parent().find('.booking-form--title').addClass('has-error');
							_self.$loginError.push("<strong>Password :</strong>Invalid Password. You have 3 more attempt(s)");
						} else if (responseCode == "W3") {
							$loginErrorDiv.show();
							$loginPassword.addClass('has-error');
							$loginPassword.parent().find('.booking-form--title').addClass('has-error');
							_self.$loginError.push("<strong>Password :</strong>Invalid Password. You have 2 more attempt(s)");
						} else if (responseCode == "W4") {
							$loginErrorDiv.show();
							$loginPassword.addClass('has-error');
							$loginPassword.parent().find('.booking-form--title').addClass('has-error');
							_self.$loginError.push("<strong>Password :</strong>Invalid Password. You have 1 more attempt(s)");
						} else if (responseCode == "ST") {
							$loginErrorDiv.show();
							$loginMHNo.addClass('has-error');
							$loginPassword.addClass('has-error');
							$loginPassword.parent().find('.booking-form--title').addClass('has-error');
							_self.$loginError.push("<strong>Account :</strong>This is invalid/inactive account. Kindly contact call center for further information");
						}else if (responseCode == "TO") {
							$loginErrorDiv.show();
							_self.$loginError.push("Sorry, we are unable to process your request at this time. please try again later.");
						}

						var $validationContainer = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
						var $validationMessagelist = $validationContainer;

						for (var i = 0, len = _self.$loginError.length; i < len; i++) {
							$validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
						}
						bcommon.preloaderClose();
					},
					error: function(error:any) {
						bcommon.preloaderClose();
					}
				});
			}
		});
	}
}

let scope:Element = document.querySelector('.login-component');
if (scope){
	try {
	let $loginBtn = $(scope).find('button.login-form');
	let loginform = new loginForm();
			loginform.loginForm();
			loginform.loginFormSubmit();
			$loginBtn.removeAttr('disabled');
	} catch(e) {console.error(e);}
}
